import { GroupedBasketItemTypes } from '../ItemListingRows';

export function groupByItemType(items): GroupedBasketItemTypes {
  return items.reduce(
    (itemsGroups, item, index) => ({
      ...itemsGroups,
      [item.type]: [...(itemsGroups[item.type] || []), { item, index }],
    }),
    {}
  );
}
